import { atom, useAtom } from 'jotai';

export const interruptChatDialogOpenAtom = atom(false);

export const useInterruptChatDialog = () => {
  const [isOpen, setIsOpen] = useAtom(interruptChatDialogOpenAtom);

  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  return { isOpen, open, close };
};
